class ConfigService {
  /* For dev -------------------  */
  //   API_URL = process.env.REACT_APP_API_URL;
  // API_URL_PAYMENT = process.env.REACT_APP_API_URL_PAYMENT;
  // PUBLIC_URL = process.env.REACT_APP_PUBLIC_URL;
  // VIDEO_URL = process.env.REACT_APP_VIDEO_URL;



  // PUBLIC_URL="http://138.201.249.173/api";
  // VIDEO_URL="http://138.201.249.173/video";


  API_URL = "https://efhonline.com/api/auth";
  API_URL_PAYMENT = "https://efhonline.com/api/pay";
  PUBLIC_URL = "https://efhonline.com/api";
  FILE_URL = "https://efhonline.com/api/file";
  VIDEO_URL = "https://video.efhonline.com";

  // API_URL = "http://138.201.249.173:8080";
  // API_URL_PAYMENT = "http://138.201.249.173:8085";
  // PUBLIC_URL = "http://138.201.249.173:8090";
  // FILE_URL = "http://138.201.249.173:8090";
  // VIDEO_URL = "https://video.efhonline.com";


  // VIDEO_URL = "http://138.201.249.173:4700";




  // VIDEO_URL = process.env.REACT_APP_VIDEO_URL;




}




export default new ConfigService();
